/* =====================================================
   BEMS HOME — Staffelrabatt Banner JS
   Cart Sync via Shopify AJAX + Focal Theme Events
   ===================================================== */

(function () {
  'use strict';

  // ── Konfiguration ──────────────────────────────────
  const CONFIG = {
    tiers: [
      { threshold: 0,   discount: 15, label: '15%' },
      { threshold: 250, discount: 20, label: '20%' },
      { threshold: 500, discount: 25, label: '25%' }
    ],
    freeShippingThreshold: 69,
    shippingPrice: 4.99,
    maxProgress: 500,
    currency: '€',
  };

  // ── DOM refs ───────────────────────────────────────
  const banner    = document.getElementById('bems-staffel-banner');
  const toggle    = document.getElementById('bems-banner-toggle');
  const content   = document.getElementById('bems-banner-content');
  const fill      = document.getElementById('bems-banner-fill');
  const trackEl   = document.getElementById('bems-banner-track');
  const titleEl   = document.getElementById('bems-banner-title');
  const statusEl  = document.getElementById('bems-banner-status');

  if (!banner) return;

  // ── Hilfsfunktionen ───────────────────────────────
  function getCurrentTierIndex(totalCents) {
    let idx = 0;
    for (let i = 0; i < CONFIG.tiers.length; i++) {
      if (totalCents >= CONFIG.tiers[i].threshold * 100) idx = i;
    }
    return idx;
  }

  // ── Banner Update ──────────────────────────────────
  function updateBanner(totalCents) {
    const total    = totalCents / 100;
    const tierIdx  = getCurrentTierIndex(totalCents);
    const tier     = CONFIG.tiers[tierIdx];
    const nextTier = CONFIG.tiers[tierIdx + 1] || null;

    // Progress Fill — startet bereits bei kleinem Wert damit 1. Dot aktiv wirkt
    const progressPct = Math.min((total / CONFIG.maxProgress) * 100, 100);
    fill.style.width = progressPct + '%';

    // Dot Positionen dynamisch setzen (exakt zur Progress-Bar)
const positions = [0, 50, 100]; // 0€=0%, 250€=50%, 500€=100%
for (let i = 0; i < CONFIG.tiers.length; i++) {
  const dot = document.getElementById('bems-dot-' + i);
  if (dot) dot.style.left = positions[i] + '%';
}

    if (trackEl) {
      trackEl.setAttribute('aria-valuenow', Math.round(total));
    }

    // Dots + Milestone Labels
    for (let i = 0; i < CONFIG.tiers.length; i++) {
      const dot = document.getElementById('bems-dot-' + i);
      const ms  = document.getElementById('bems-ms-' + i);
      // Erster Dot ist immer aktiv (15% gilt ab 0€)
      const isActive = i === 0 ? true : i <= tierIdx;
      if (dot) dot.classList.toggle('is-active', isActive);
      if (ms)  ms.classList.toggle('is-active', isActive);
    }

    // Header Titel
    let titleHTML = '';
    if (total === 0) {
      titleHTML = 'Spare bis zu <strong>25% </strong> automatisch an der Kasse';
    } else if (total < CONFIG.freeShippingThreshold) {
      titleHTML = 'Du sparst <strong>' + tier.label + ' </strong> automatisch an der Kasse!';
    } else {
      titleHTML = 'Du sparst <strong>' + tier.label + ' </strong> automatisch an der Kasse!';
    }
    titleEl.innerHTML = titleHTML;

    // Status Zeile
    let statusHTML = '';
    if (total === 0) {
  statusHTML = 'Du startest direkt mit <strong>15% Rabatt</strong> — spare bis zu 25%';
} else if (nextTier) {
  const remNext = (nextTier.threshold - total).toFixed(2).replace('.', ',');
  statusHTML = 'Gebe noch <strong>' + remNext + ' €</strong> aus für <strong>' + nextTier.label + ' Rabatt</strong>';
} else {
  statusHTML = 'Maximaler Rabatt <strong>25%</strong> erreicht 🎉';
}
statusEl.innerHTML = statusHTML;

    updateBodyPadding();
  }

  // ── Body Padding ───────────────────────────────────
  function updateBodyPadding() {
    requestAnimationFrame(function () {
      const height = banner.getBoundingClientRect().height;
      document.body.style.setProperty('--bems-banner-height', (height + 20) + 'px');
    });
  }

  // ── Mobile Toggle ──────────────────────────────────
  function setupToggle() {
    if (!toggle || !content) return;

    const isMobile = window.matchMedia('(max-width: 989px)');

    function applyView() {
      if (!isMobile.matches) {
        content.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        if (content.getAttribute('data-initialized') !== '1') {
          content.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
          content.setAttribute('data-initialized', '1');
        }
      }
      updateBodyPadding();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!isMobile.matches) return;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      if (isExpanded) {
        content.setAttribute('hidden', '');
      } else {
        content.removeAttribute('hidden');
      }
      updateBodyPadding();
    });

    document.getElementById('bems-banner-header').addEventListener('click', function () {
      if (isMobile.matches) toggle.click();
    });

    isMobile.addEventListener('change', applyView);
    applyView();
  }

  // ── Cart API Fetch ─────────────────────────────────
  function fetchCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBanner(cart.total_price || 0); })
      .catch(function (err) { console.warn('[Bems Banner] Cart fetch fehlgeschlagen:', err); });
  }

  // ── Focal Theme Event Listener ─────────────────────
  document.addEventListener('cart:updated', function (event) {
    const total = event.detail && event.detail.cart ? event.detail.cart.total_price : null;
    if (total !== null) updateBanner(total);
    else fetchCart();
  });

  // MutationObserver Backup auf mini-cart
  const miniCart = document.getElementById('mini-cart');
  if (miniCart) {
    new MutationObserver(fetchCart).observe(miniCart, { childList: true, subtree: true });
  }

  document.addEventListener('cart-update', fetchCart);
  document.addEventListener('cartUpdate', fetchCart);

  // ── Drawer Visibility ──────────────────────────────
  function hideBanner() {
    banner.style.transform = 'translateY(calc(100% + 20px))';
    banner.style.pointerEvents = 'none';
  }

  function showBanner() {
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (isDesktop) {
      banner.style.transform = 'translateX(50%)';
    } else {
      banner.style.transform = 'translateY(0)';
    }
    banner.style.pointerEvents = '';
  }

  document.addEventListener('drawer:open', hideBanner);
  document.addEventListener('drawer:close', showBanner);

  const bodyObserver = new MutationObserver(function () {
    const drawerOpen =
      document.body.classList.contains('drawer-open') ||
      document.body.classList.contains('is-drawer-open') ||
      document.querySelector('.drawer.is-open, .drawer[open]') !== null;
    drawerOpen ? hideBanner() : showBanner();
  });
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.querySelectorAll('.drawer').forEach(function (drawer) {
    new MutationObserver(function () {
      const anyOpen = document.querySelector('.drawer.is-open, .drawer[open]') !== null;
      anyOpen ? hideBanner() : showBanner();
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
  });

  // ── Varianten Picker Beobachter ───────────────────
function checkVariantPicker() {
  const pickerOpen = document.querySelector(
    '.product-form.test.newBundle div#pick-color-id .color-selection__selection-container[style="display: flex;"]'
  );
  pickerOpen ? hideBanner() : showBanner();
}

const variantObserver = new MutationObserver(checkVariantPicker);
const variantPicker = document.querySelector('.product-form.test.newBundle div#pick-color-id');

if (variantPicker) {
  variantObserver.observe(variantPicker, {
    attributes: true,
    attributeFilter: ['style'],
    subtree: true,
    childList: true
  });
}

  // ── Hide Button (Desktop) ──────────────────────────
  const hideBtn = document.getElementById('bems-banner-hide');
  if (hideBtn) {
    hideBtn.addEventListener('click', function () {
      banner.style.transform = 'translateY(calc(100% + 30px))';
      banner.style.pointerEvents = 'none';
      sessionStorage.setItem('bems-banner-hidden', '1');
    });
  }

  if (sessionStorage.getItem('bems-banner-hidden') === '1') {
    hideBanner();
  }

  // ── Init ──────────────────────────────────────────
  setupToggle();
  fetchCart();

  window.addEventListener('resize', updateBodyPadding, { passive: true });

})();

